import React from 'react'
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './PandaButton.scss';
import { PIDE_PANDA } from '../../images/images';

export default function PandaButton(props) {
    return (
        <Link to={{
            pathname:'/shop',
            }}>
            <Image src={PIDE_PANDA} className="pide-panda-button" height={100} width={100} roundedCircle fluid/>
        </Link>
    )
}
